/**
 * Selectable table row for a bulk RMA action request summary.
 */
import DateTimeV2, { DATETIME_VIEW } from '../../../../../../components/datetime-v2/datetime-v2';
import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import TableRow from '../../../../../../components/table/components/table-row/table-row';
import { useDateTimeFormattingParams } from '../../../../../../hooks/use-datetime-formatting-params';
import { IBulkRmaActionRequestSummary } from '../../../../../../services/api/troubleshooting-service';
import {
    ACTION_TYPE_LABELS,
    REQUEST_STATUS_LABELS,
} from '../../utils/bulk-rma-action-labels';
import BulkRmaStatusChip from '../bulk-rma-status-chip/bulk-rma-status-chip';

interface IRequestTableRowProps {
    request: IBulkRmaActionRequestSummary;
    unresolved: number;
    onSelect: (requestId: number) => void;
}

const RequestTableRow: React.FC<IRequestTableRowProps> = ({
    request,
    unresolved,
    onSelect,
}) => {
    const dateTimeParams = useDateTimeFormattingParams();

    const cells = [
        <FontBody2>#{request.request_id}</FontBody2>,
        <FontBody2>{ACTION_TYPE_LABELS[request.action] ?? request.action}</FontBody2>,
        <BulkRmaStatusChip
            status={request.status}
            label={REQUEST_STATUS_LABELS[request.status] ?? request.status}
        />,
        <FontBody2>{request.counts.total}</FontBody2>,
        <span className={unresolved > 0 ? 'bulk-rma-actions-page__emphasis' : undefined}>
            <FontBody2>{unresolved}</FontBody2>
        </span>,
        <FontBody2>{request.counts.succeeded}</FontBody2>,
        <FontBody2>{request.counts.blocked}</FontBody2>,
        <FontBody2>{request.counts.error}</FontBody2>,
        <FontBody2>
            <DateTimeV2
                {...dateTimeParams}
                utcDateString={request.created_at ?? ''}
                dateTimeView={DATETIME_VIEW.FULL}
            />
        </FontBody2>,
        <FontBody2>
            <DateTimeV2
                {...dateTimeParams}
                utcDateString={request.last_progress_at ?? ''}
                dateTimeView={DATETIME_VIEW.FULL}
            />
        </FontBody2>,
        <FontBody2>
            <DateTimeV2
                {...dateTimeParams}
                utcDateString={request.finished_at ?? ''}
                dateTimeView={DATETIME_VIEW.FULL}
            />
        </FontBody2>,
    ];

    return (
        <TableRow
            name={`bulk-request-${request.request_id}`}
            onSelect={() => onSelect(request.request_id)}
            skipWrapingCell
            cells={cells}
        />
    );
};

export default RequestTableRow;
